import { render, staticRenderFns } from "./card-branchesDetails.vue?vue&type=template&id=52636296&scoped=true&"
import script from "./card-branchesDetails.vue?vue&type=script&lang=js&"
export * from "./card-branchesDetails.vue?vue&type=script&lang=js&"
import style0 from "./card-branchesDetails.vue?vue&type=style&index=0&id=52636296&prod&lang=scss&scoped=true&"
import style1 from "./card-branchesDetails.vue?vue&type=style&index=1&id=52636296&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52636296",
  null
  
)

export default component.exports